import { render, staticRenderFns } from "./DeliveryReviews.vue?vue&type=template&id=3e9248f4&scoped=true&"
import script from "./DeliveryReviews.vue?vue&type=script&lang=js&"
export * from "./DeliveryReviews.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryReviews.vue?vue&type=style&index=0&id=3e9248f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9248f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VApp,VBtn,VImg,VRating})
